import styled from 'styled-components';

import { COLORS } from '../../assets/js/constants';
import { FONTS } from '../../tokens/fonts';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
`;

export const ProgressBar = styled.div`
    position: relative;
    display: block;
    width: 100%;
    height: ${p => p.width}px;
    background-color: ${p => p.background};
    border-radius: ${p => p.borderRadius}px;
    overflow: hidden;
`;

export const Bar = styled.div`
    display: block;
    height: 100%;
    ${p => p.smooth && `transition: width ${p.animationDuration}s;`}
    top: 0;
    background-color: ${p => p.color};
    border-radius: ${p => p.borderRadius}px;
`;

export const Title = styled.div`
    display: block;
    ${FONTS.L};
    margin-bottom: 10px;
    color: ${COLORS.black};
    @media(max-width: 1080px) {
        ${FONTS.S};
        margin-bottom: 8px;
    }
`;

export const Description = styled.div`
    display: block;
    ${FONTS.S};
    color: ${COLORS.grey};
    margin-top: 6px;
    @media(max-width: 1080px) {
        ${FONTS.XS};
    }
`;
